const MAX_RETRIES = 2;

/**
 * shared TanStack Query retry policy. client errors are final: a 401 or 404 will
 * never succeed on retry and retrying would only delay the empty state the user
 * should see. everything else (5xx, network) gets a couple of attempts.
 * @param failureCount - how many times the query has already failed
 * @param error - the error thrown by the queryFn, an ApiError when it came from apiRequest
 */
export default function retryApiRequest(failureCount, error) {
  const status = error?.status;
  if (status >= 400 && status < 500) return false;
  return failureCount < MAX_RETRIES;
}
